module.exports = __webpack_public_path__ + "static/media/gasnet32_1.4780aafe.gif";